$('.nav-pills').on('click', function(e){
    $('li', this).removeClass('active');
    $(e.target).parent('li').addClass('active');
});